import { render, staticRenderFns } from "./DesenvolvimentoAplicativosBC.vue?vue&type=template&id=604fb010&scoped=true"
import script from "./DesenvolvimentoAplicativosBC.vue?vue&type=script&lang=js"
export * from "./DesenvolvimentoAplicativosBC.vue?vue&type=script&lang=js"
import style0 from "./DesenvolvimentoAplicativosBC.vue?vue&type=style&index=0&id=604fb010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604fb010",
  null
  
)

export default component.exports